import { connect } from 'react-redux';
import { setDate, setDateArray, setSeasonType, setZoomBreakRoom } from '../Header.action';
import { setUser } from '../UserInformation/UserInformation.action';
import MobileFork from './MobileFork';
import { cloneDeep } from 'lodash';

const mapDispatchToProps = (dispatch) => {
  return {
    setReduxDateArray: (dateArray) => dispatch(setDateArray(dateArray)),
    setReduxDate: (date, id) => {
      return dispatch(setDate(cloneDeep(date)));
    },
    setUser: (userObject) => dispatch(setUser(userObject)),
    setSeasonType: (seasonType) => dispatch(setSeasonType(seasonType)),
    setZoomBreakRoom: (meetingLink) => dispatch(setZoomBreakRoom(meetingLink)),
  };
};

const mapStateToProps = (state) => {
  const { headerHeight, dateArray, date } = state.header;
  return {
    headerHeight,
    reduxDateArray: dateArray,
    reduxDate: date,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFork);
